import {
  FETCH_CONTENTFUL_REQUEST,
  FETCH_CONTENTFUL_SUCCESS,
  FETCH_CONTENTFUL_ERROR
} from './actions';

export default function contentfulReducer(
  state = {
    items: [],
    isFetching: false,
    error: null
  },
  action
) {
  switch (action.type) {
    case FETCH_CONTENTFUL_REQUEST:
      return { ...state, error: null, isFetching: true };
    case FETCH_CONTENTFUL_SUCCESS:
      return {
        ...state,
        items: action.payload.items,
        isFetching: false
      };
    case FETCH_CONTENTFUL_ERROR:
      return { ...state, error: action.payload, isFetching: false };
    default:
      return state;
  }
}
